export interface Publication {
  logo?: string;
  arxivLogo?: string;
  publisher: string;
  title: string;
  authors: string[];
  date: string;
  conference?: string;
  doi?: string;
  tags: string[];
  abstract: string;
  previewImage?: string;
  color?: string;
}

export const publications: Publication[] = [
  {
    logo: '/content/cornell1.svg',
    arxivLogo: '/content/arxiv.svg',
    publisher: 'Cornell University arXiv',
    title: 'Artificial Empathy: AI based Mental Health',
    authors: ['Aditya Naik', 'Jovi Thomas', 'Teja Sree', 'Himavant Reddy'],
    date: 'May 30, 2025',
    conference: 'SIGCHI Preprint',
    doi: 'https://doi.org/10.48550/arXiv.2506.00081',
    tags: ['First Author', 'Other Quantitative Biology', 'Human-Computer Interaction'],
    abstract: 'The research examines how individuals utilize AI chatbots for mental health support. Key findings indicate users value chatbots as accessible, judgment-free companions offering anonymity.',
    previewImage: '/content/paper1.png',
    color: '#B31B1B',
  },
  {
    logo: '/content/IEEE.svg',
    publisher: 'IEEE',
    title: 'Driver Drowsiness Detection using Smart Glasses',
    authors: ['Aditya Naik', 'Priyadarshan Wagh', 'Riya Kosta', 'Vijay Oli', 'Shailendra Aswale'],
    date: 'November 13, 2024',
    conference: '2024 4th International Conference on Technological Advancements in Computational Sciences (ICTACS)',
    doi: 'https://doi.org/10.1109/ICTACS62700.2024.10841148',
    tags: ['First Author', 'Driver Safety', 'Machine Learning'],
    abstract: 'The system addresses traffic safety by detecting driver fatigue using smart glasses with Raspberry Pi 4 technology. It analyzes facial features through Eye Aspect Ratio and Mouth Aspect Ratio for classification.',
    previewImage: '/content/paper2.png',
    color: '#00629B',
  },
];
